import ConfigKelas from "../../../../../components/categories/siakad/lms/data_kelas/subpage/Home";
export default function Home() {
  
  return (
    <ConfigKelas />
  );
}
